import AppButton from "@/components/AppButton";
import { MessageSquare } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Icon } from "@iconify/react";

const DiscordCommunitySection = () => {
  const { t } = useTranslation();

  return (
    <section className="py-16 bg-black">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row-reverse items-center gap-12 p-10 rounded-xl">
          <div className="flex-1">
            <h2 className="text-2xl md:text-3xl font-bold mb-6 text-white font-sans">{t('discord.title', 'Join Our Discord Community')}</h2>
            <p className="text-gray-300 mb-8">
              {t('discord.description', 'Connect with MysteryAct enthusiasts, find players, and share experiences in our growing community.')}
            </p>
            <AppButton
              external
              to="https://discord.com/invite/qr3HPC5AkH"
              className="flex items-center justify-center gap-2 bg-[#5865F2] text-white text-base hover:bg-[#4752C4] transition-colors"
            >
              <Icon icon="line-md:discord" className="h-5 w-5" />
              {t('discord.button', 'Join Discord')}
            </AppButton>
          </div>
          <div className="flex-1 flex justify-center relative">
            <div className="p-8 rounded-xl shadow-lg flex items-center justify-center">
              <img
                src="/img/discord.gif"
                className="w-60 md:w-80 object-cover rounded-xl shadow-md"
                alt="Discord Logo"
                style={{
                  filter: "drop-shadow(0 0 1px rgba(255,255,255,0.3))"
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DiscordCommunitySection;
